import React from "react";

import styles from "./EmptyState.module.scss";
import emptyImage from "@/assets/img/newEmpty.svg";

type Props = {
  img?: any;
  icon?: React.ReactNode;
  title?: string;
  text?: string;
  className?: string;
  backgroundColor?: string;
  action?: React.ReactNode;
};

const EmptyState = ({ img, icon, title, text, className = "", backgroundColor, action }: Props) => {
  return (
    <div
      className={`${styles.emptyState} ${className} gradientBorder`}
      style={{ background: backgroundColor }}
    >
      {icon ? (
        <span className={styles.emptyStateIcon}>{icon}</span>
      ) : (
        <img src={img || emptyImage} />
      )}
      <h3>{title}</h3>
      <p>{text}</p>
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
};

export default EmptyState;
